<template>
  <el-dialog
    :title="dialogTitle"
    :modal-append-to-body="true"
    :append-to-body="true"
    :before-close="handleClose"
    width="500px"
    class="material_dialog"
    custom-class="material_dialog"
    :visible="true"
  >
    <div v-loading="isLoading" class="DefaultStyleComponent">
      <div class="img-list">
        <el-checkbox :indeterminate="isIndeterminate" v-model="isCheckedAll" @change="handleCheckAllChange">{{$t('components_material_save_dialog_index_2199')}}</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedImgs" @change="handleCheckedImgChange">
          <div class="img-wrapper" v-for="(img,index) in imgList" :key="img.rowId">
            <div class="img-loading-wrapper" v-if="img.loading">
              <i class="el-icon-loading"></i>
              <span>{{$t('components_material_save_dialog_index_2200')}}</span>
            </div>
            <el-checkbox v-else :label="img.rowId" :key="img.rowId">
              <img style="width: 220px;
                height: 100px;
                object-fit: contain;" :src="img.url" alt="">
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="sel" style="margin-top: 16px;" v-if="isDesigner">
        <span class="title">{{$t('components_material_save_dialog_index_2201')}}</span>
        <el-select v-model="styleSaveObj.pid" :placeholder="$t('view_dialog_index_116')">
          <el-option
            v-for="item in $store.state.options.group_type_list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-radio-group v-model="styleSaveObj.public" class="my_radio">
          <el-radio label="false">{{$t('components_material_save_dialog_index_2202')}}</el-radio>
          <el-radio label="true">{{$t('components_material_save_dialog_index_2203')}}</el-radio>
        </el-radio-group>
      </div>
      <div style="margin-top: 16px; margin-bottom: 8px;">{{$t('components_material_save_dialog_index_2204')}}</div>
      <div class="addStyle_imgFrame">
        <div v-if="false && imgLoading">
          <i class="el-icon-loading"></i>
          <span>{{$t('components_material_save_dialog_index_2200')}}</span>
        </div>
        <template v-else>
          <my_img_cover :firstModel.sync="styleSaveObj.img"></my_img_cover>
          <p v-if="!styleSaveObj.img && !checkedImgs.length">{{$t('components_material_save_dialog_index_2205')}}</p>
          <img v-else-if="styleSaveObj.img" :src="styleSaveObj.img + '?ct=webp'"/>
          <canvas v-if="checkedImgs.length && !styleSaveObj.img" id="canvas" width="450"></canvas>
          <img class="img-body" style="display: none;" :src="bodyImgUrl + '?ct=webp'" crossOrigin="anonymous"/>
        </template>
      </div>
      <el-input v-model="styleSaveObj.name" :placeholder="$t('components_material_save_dialog_index_2206')"></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="isBtnLoading" @click="addStyleSure">{{$t('view_public_topbar_15')}}</el-button>
      <el-button @click="handleClose">{{$t('view_public_topbar_14')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {save_material, get_material_group_count, uploadyunfile} from "@/api/app";
import html2canvas from 'html2canvas'

export default {
  name: "template_save_dialog",
  props: {
    type: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      styleSaveObj: {
        name: "",
        widget_name: "",
        style: "",
        img: "",
        public: "true",
        pid: "12"
      },
      imgDataUrl: '',
      myMaterialId: '99',
      myMaterialName: i18n.t('view_left_sidebar_module_add_material_232'),
      myMaterialCount: 1,
      isLoading: false,
      isBtnLoading: true,
      imgLoading: true,
      imgList: [], // {url, loading}
      isCheckedAll: false,
      isIndeterminate: false,
      checkedImgs: [],
      bodyImgUrl: '',
    };
  },
  computed: {
    isDesigner() {
      return this.$store.state.app.role === 'designer'
    },
    dialogTitle() {
      return this.isDesigner ? i18n.t('components_material_save_dialog_index_2978') : i18n.t('components_material_save_dialog_index_2207')
    }
  },
  watch: {
    checkedImgs() {
      if (!this.checkedImgs.length) {
        return
      }
      if (this.styleSaveObj.img) {
        return
      }
      setTimeout(() => {
        this.generateCoverImg()
      })
    }
  },
  methods: {
    handleClose() {
      this.close();
    },
    //确认选择
    addStyleSure() {
      if (!this.checkedImgs.length) {
        this.$message.error(i18n.t('components_material_save_dialog_index_2208'));
        return;
      }

      if (!this.styleSaveObj.name) {
        this.$message.error(i18n.t('components_material_save_dialog_index_2209'));
        return;
      }

      if (this.isBtnLoading) {
        return;
      }

      if (!this.styleSaveObj.img) {
        const canvas = document.querySelector('#canvas')
        let dataURL = canvas.toDataURL('image/png');
        let file = this.dataURIToFile(dataURL, i18n.t('components_material_save_dialog_index_2210', [this.myMaterialCount]))
        this.uploadFile(file).then(res => {
          this.styleSaveObj.img = res.data.filePath
          if (res.code !== 200) {
            return this.$message.error(res.message || i18n.t('components_material_save_dialog_index_2211'))
          }
          this.save()
        })
        return;
      }

      this.save()
    },
    save() {
      const rows = this.$store.state.myRender.body.filter(item => this.checkedImgs.includes(item.widgets_id))

      let SaveObj = {
        group_name: this.styleSaveObj.name,
        img: this.styleSaveObj.img,
        pid: this.isDesigner ? this.styleSaveObj.pid : this.myMaterialId,
        public: this.isDesigner ? this.styleSaveObj.public : 'false',
        params: JSON.stringify(rows)
      };

      this.isBtnLoading = true

      save_material(SaveObj)
        .then(e => {
          if (e.code == 200) {
            this.$message.success({
              showClose: true,
              message: i18n.t('base_row_y _ 副本_1935')
            });
            this.isBtnLoading = false
            this.$store.commit("app/set_material_save_isShow", false);
          } else {
            this.$message.error(e.message);
          }
        })
        .catch(() => {
          this.isBtnLoading = false
          this.$message.error(i18n.t('base_row_y _ 副本_1937'));
        });
    },
    close() {
      this.$store.commit("app/set_material_save_isShow", false);
    },
    autoCompleteName() {
      this.getMyMaterialCount().then(res => {
        let count = res.data
        this.myMaterialCount = count
        this.styleSaveObj.name = i18n.t('components_material_save_dialog_index_2212', [count + 1])
      })
    },
    getMyMaterialCount() {
      return get_material_group_count({
        pid: this.myMaterialId
      })
    },
    initImgList() {
      const rows = this.$store.state.myRender.body
      this.imgList = rows.map(row => {
        return {
          rowId: row.widgets_id,
          url: '',
          loading: true,
        }
      })
    },
    getImgListImgUrl() {
      const rows = this.$store.state.myRender.body
      const bodyHeight = document.querySelector(`.mybody.layout_body`).offsetHeight
      const bodyWidth = document.querySelector(`.mybody.layout_body`).offsetWidth
      this.imgList = rows.map(row => {
        let elRow = document.querySelector(`#u${row.widgets_id}`)
        const elHeight = elRow.offsetHeight
        const offsetTop = elRow.offsetTop
        const scale = 1
        const pos = {
          w: Math.floor(bodyWidth * scale),
          h: Math.floor(elHeight * scale),
          x: 0,
          y: Math.floor(offsetTop * scale)
        }
        const crop = `?crop=${pos.w}x${pos.h}a${pos.x}a${pos.y}&ct=webp`
        const url = this.bodyImgUrl
        return {
          rowId: row.widgets_id,
          url: url + crop,
          loading: false,
          rowOffsetHeight: elHeight,
          rowOffsetTop: offsetTop,
        }
      })
    },
    getSingleImg(row) {
      let rowId = row.widgets_id
      let elRow = document.querySelector(`#u${rowId}`)
      var canvas2 = document.createElement("canvas");
      var w = parseInt(window.getComputedStyle(elRow).width);
      var h = parseInt(window.getComputedStyle(elRow).height);
      //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
      canvas2.width = parseInt(w * 1.5);
      canvas2.height = parseInt(h * 1.5);
      canvas2.style.width = w + "px";
      canvas2.style.height = h + "px";
      //可以按照自己的需求，对context的参数修改,translate指的是偏移量
      var context = canvas2.getContext("2d");
      // context.scale(2, 2);
      context.scale(1.5, 1.5);
      html2canvas(elRow, {
        canvas: canvas2,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 5000,
      }).then((canvas) => {
        // document.body.appendChild(canvas);
        let dataURL = canvas.toDataURL();
        this.imgList.forEach(img => {
          if (img.rowId === rowId) {
            img.url = dataURL
            img.loading = false
          }
        })
        // this.imgDataUrl = dataURL
        // this.imgLoading = false
        // 感觉没必要保存
        // let file = this.dataURIToFile(dataURL, `我的素材${this.myMaterialCount}.png`)
        // this.uploadFile(file).then(res => {
        //   console.log('res', res)
        //   this.styleSaveObj.img = res.data.filePath
        //   this.isBtnLoading = false
        //   this.imgLoading = false
        //   if (res.code !== 200) {
        //     this.$message.error(res.message)
        //   }
        // }).catch(() => {
        //
        // })
      }).catch(() => {
        this.isBtnLoading = false
        this.imgLoading = false
      });
    },
    getImg() {
      let rowId = this.$store.state.row_contextmenu_dialog.contextmenu_obj.widgets_id
      let elRow = document.querySelector(`#u${rowId}`)
      var canvas2 = document.createElement("canvas");
      var w = parseInt(window.getComputedStyle(elRow).width);
      var h = parseInt(window.getComputedStyle(elRow).height);
      //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
      canvas2.width = parseInt(w * 1.5);
      canvas2.height = parseInt(h * 1.5);
      canvas2.style.width = w + "px";
      canvas2.style.height = h + "px";
      //可以按照自己的需求，对context的参数修改,translate指的是偏移量
      var context = canvas2.getContext("2d");
      // context.scale(2, 2);
      context.scale(1.5, 1.5);
      html2canvas(elRow, {
        canvas: canvas2,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 5000,
      }).then((canvas) => {
        // document.body.appendChild(canvas);
        let dataURL = canvas.toDataURL();
        this.imgDataUrl = dataURL
        this.imgLoading = false
        let file = this.dataURIToFile(dataURL, i18n.t('components_material_save_dialog_index_2210', [this.myMaterialCount]))
        this.uploadFile(file).then(res => {
          console.log('res', res)
          this.styleSaveObj.img = res.data.filePath
          this.isBtnLoading = false
          this.imgLoading = false
          if (res.code !== 200) {
            this.$message.error(res.message)
          }
        }).catch(() => {

        })
      }).catch(() => {
        this.isBtnLoading = false
        this.imgLoading = false
      });
    },
    getBodyImg() {
      const scale = 1
      let elRow = document.querySelector(`.mybody.layout_body`)
      var canvas2 = document.createElement("canvas");
      var w = parseInt(window.getComputedStyle(elRow).width);
      var h = parseInt(window.getComputedStyle(elRow).height);
      //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
      canvas2.width = parseInt(w * scale);
      canvas2.height = parseInt(h * scale);
      canvas2.style.width = w + "px";
      canvas2.style.height = h + "px";
      //可以按照自己的需求，对context的参数修改,translate指的是偏移量
      var context = canvas2.getContext("2d");
      context.scale(scale, scale);
      html2canvas(elRow, {
        canvas: canvas2,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 5000,
      }).then((canvas) => {
        // document.body.appendChild(canvas);
        let dataURL = canvas.toDataURL();
        this.imgDataUrl = dataURL
        this.imgLoading = false
        let file = this.dataURIToFile(dataURL, i18n.t('components_material_save_dialog_index_2210', [this.myMaterialCount]))
        this.uploadFile(file).then(res => {
          console.log('res', res)
          // this.styleSaveObj.img = res.data.filePath
          this.bodyImgUrl = res.data.filePath
          this.isBtnLoading = false
          this.imgLoading = false
          this.getImgListImgUrl()
          if (res.code !== 200) {
            this.$message.error(res.message)
          }
        }).catch(() => {

        })
      }).catch(() => {
        this.isBtnLoading = false
        this.imgLoading = false
      });
    },
    uploadFile(data) {
      let param = new FormData()
      param.append('file', data)
      param.append('folderId', 0)
      return uploadyunfile(param)
    },
    dataURIToFile(ndata, fileName) {
      // ndata为base64格式地址
      let arr = ndata.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, {type: mime})
    },
    handleCheckAllChange(val) {
      this.checkedImgs = val ? this.imgList.map(img => img.rowId) : [];
      this.isIndeterminate = false;
      this.isCheckedAll = val
    },
    handleCheckedImgChange(value) {
      console.log('checkedImgs', this.checkedImgs)
      let checkedCount = value.length;
      this.isCheckedAll = checkedCount === this.imgList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedImgs.length
    },
    generateCoverImg() {
      const canvas = document.querySelector('#canvas')
      const ctx = canvas.getContext('2d');
      const sourceImage = document.querySelector('.img-body')
      const canvasWidth = canvas.offsetWidth
      let canvasHeight = 0
      const bodyWidth = document.querySelector(`.mybody.layout_body`).offsetWidth
      const imgWidth = sourceImage.naturalWidth
      this.checkedImgs.forEach(rowId => {
        const imgData = this.imgList.find(d => d.rowId === rowId)
        const scales = canvasWidth / imgWidth
        const rowHeight = imgData.rowOffsetHeight
        const canvasPartHeight = rowHeight * scales
        canvasHeight = canvasHeight + canvasPartHeight
      })

      canvas.height = canvasHeight
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let currentImageY = 0
      let currentCanvasY = 0
      this.checkedImgs.forEach(rowId => {
        const imgData = this.imgList.find(d => d.rowId === rowId)
        const scales = canvasWidth / bodyWidth
        const rowHeight = imgData.rowOffsetHeight
        const canvasPartHeight = rowHeight * scales
        this.drawPartCanvas({
          ctx,
          sourceImage,
          sourceImgPosition: {
            x: 0,
            y: imgData.rowOffsetTop,
            width: imgWidth,
            height: rowHeight,
          },
          targetCanvasPosition: {
            x: 0,
            y: currentCanvasY,
            width: canvasWidth,
            height: canvasPartHeight
          }
        })
        currentImageY = currentImageY + rowHeight + 1
        currentCanvasY = currentCanvasY + canvasPartHeight
      })
    },
    drawPartCanvas({
                     ctx,
                     sourceImage, sourceImgPosition, targetCanvasPosition
                   }) {
      ctx.drawImage(sourceImage, sourceImgPosition.x, sourceImgPosition.y, sourceImgPosition.width, sourceImgPosition.height,
        targetCanvasPosition.x, targetCanvasPosition.y, targetCanvasPosition.width, targetCanvasPosition.height);
    }
  },
  created() {
    if (!this.isDesigner) {
      this.getMyMaterialCount()
      this.autoCompleteName()
    }
    this.initImgList()
    this.getBodyImg()
    // this.getImg()
  }
};
</script>

<style lang="scss" scoped>
.material_dialog {
  .my_radio {
    float: right;
    margin-left: 10px;
    margin-top: 12px;
  }

  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;

      .el-button {
        margin: 8px 18px;
        padding: 0 28px;
        height: 34px;
      }
    }
  }

  .img-list {
    max-height: 240px;
    overflow-y: auto;
    padding-left: 5px;

    .img-wrapper {
      display: inline-block;
      vertical-align: top;
      width: 210px;
      position: relative;
      margin-bottom: 20px;
      box-shadow: 2px 3px 7px 0 rgba(0, 0, 0, .2);

      &:nth-child(odd) {
        margin-right: 20px;
      }

      /deep/ .el-checkbox {
        width: 100%;

        .el-checkbox__input {
          position: absolute;
          top: 10px;
          left: 10px;
        }

        .el-checkbox__label {
          padding: 0;
          vertical-align: top;
        }
      }
    }
  }
}

.img-loading-wrapper {
  font-size: 12px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.img-wrapper {

}

.addStyle_imgFrame {
  overflow-y: auto;
}

#canvas {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/material_save_dialog/index.vue